<template>
<div class="WithdrawalUserList padding-20">
    <div class="bgc box-shadow title">
        <div class="classes blod">提现列表<span class="tip">右侧选择对应活动，获取数据</span></div>
        <el-select v-model="param.eventinnerid" placeholder="请输入关键词选择" filterable remote :disabled="flag"
                   reserve-keyword :remote-method="remoteMethod" :loading="loading" @change="handleSearch">
            <el-option v-for="(item,index) in activityList" :key="index" :label="item.title" :value="item.innerid">{{item.title}}</el-option>
        </el-select>
    </div>
    <div class="data-total">
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">返现总金额</div>
                    <div class="box-data"><span class="data">{{item.totalbrokerage}}</span>元</div>
                </div>
            </div>
            <el-tooltip content="当前活动直接/间接返现金额" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">分销已提金额</div>
                    <div class="box-data"><span class="data">{{item.oversettlemoney}}</span>元</div>
                </div>
            </div>

            <el-tooltip content="分销用户已经提现的金额" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">分销未提金额</div>
                    <div class="box-data"><span class="data">{{item.unsettlemoney}}</span>元</div>
                </div>
            </div>

            <el-tooltip content="分销用户还未发起提现申请的金额" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">分销待确认金额</div>
                    <div class="box-data"><span class="data">{{item.localsettlemoney}}</span>元</div>
                </div>
            </div>
            <el-tooltip content="已发起申请待确认的金额" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
    </div>
    <div class="result-list btn-operate-list padding-20 bgc" style="margin-top: 24px;">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="提现申请" name="apply">
                <div class="filters padding-20 bgc">
                    <div class="add">
                        <el-button v-if="permission.btnList.indexOf('A09')==-1" type="success" @click="handleApplyExport" class="withdrawalUserExp">导出excel</el-button>
                    </div>
                    <div class="search">
                        <el-select v-model="param.applyStatus" placeholder="请选择" @change="handleApplyQuery">
                            <el-option v-for="item in statusList" :key="item.code" :label="item.name" :value="item.code">{{item.name}}</el-option>
                        </el-select>
                    </div>
                </div>
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="cashno" label="申请编号"></el-table-column>
                    <el-table-column prop="customername" label="申请人" class-name="center"></el-table-column>
                    <el-table-column prop="datetime" label="申请时间" class-name="center"></el-table-column>
                    <el-table-column prop="cashtypename" label="提现类型" class-name="center"></el-table-column>
                    <el-table-column prop="cashmoney" label="提现金额" class-name="center">
                        <template slot-scope="scope">￥{{scope.row.cashmoney}}</template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" class-name="center">
                        <template slot-scope="scope">
                            <span :class="status(scope.row.status)">{{scope.row.statusname}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="authdesp" label="原因" class-name="right">
                        <template slot-scope="scope">
                            <span >{{scope.row.authdesp? scope.row.authdesp :'--'}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background @current-change="_getList" :current-page.sync="tableApplyPage.page" :page-size="tableApplyPage.pageSize"
                               :pager-count="11" layout="prev, pager, next" :total="total">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="可提现用户" name="user">
                <div class="filters padding-20 bgc">
                    <div class="add">
                        <el-button v-if="permission.btnList.indexOf('A09')==-1" type="success" @click="handleUserExport" class="withdrawalUserExp">导出excel</el-button>
                    </div>
                    <div class="search">
                        <!--<el-select v-model="param.userStatus" placeholder="请选择" @change="handleUserQuery">-->
                            <!--<el-option v-for="item in statusList" :key="item.code" :label="item.name" :value="item.code">{{item.name}}</el-option>-->
                        <!--</el-select>-->
                    </div>
                </div>
                <el-table :data="tableUserData" style="width: 100%">
                    <el-table-column prop="customername" label="用户昵称" width="200px">
                        <template slot-scope="scope">
                            <div class="imageText">
                                <img v-lazy="scope.row.customericonurl" :alt="scope.row.subject" preview="videoList">
                                <div class="imageText-summary">
                                    <span>{{scope.row.customername}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="直接上级" class-name="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.parentusername ? scope.row.parentusername : '--'}}</span>
                            <!-- <span>--</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column prop="invitecount" label="邀请人数" class-name="center"></el-table-column>
                    <el-table-column prop="ordercount" label="分销订单数" class-name="center"></el-table-column>
                    <!-- <el-table-column prop="ordermoney" label="分销订单额" class-name="center"></el-table-column> -->
                    <el-table-column prop="totalbrokerage" label="累计返现" class-name="center">
                        <template slot-scope="scope">￥{{scope.row.totalbrokerage}}</template>
                    </el-table-column>
                    <el-table-column prop="maysettlemoney" label="可提现金额" class-name="center">
                        <template slot-scope="scope">￥{{scope.row.maysettlemoney}}</template>
                    </el-table-column>
                    <el-table-column prop="oversettlemoney" label="已提现金额" class-name="center">
                        <template slot-scope="scope">￥{{scope.row.oversettlemoney}}</template>
                    </el-table-column>
                </el-table>
                <el-pagination background @current-change="_getUserList" :current-page.sync="tableUserPage.page" :page-size="tableUserPage.pageSize"
                               :pager-count="11" layout="prev, pager, next" :total="tableUserPagetotal">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getUserMayApplyCashList, getSimpleDisEventPageList, getUserCashInfoSum, getUserApplyCashList, exportUserApplyCashList, exportUserMayApplyCashList} from 'api/nationalDistribution'
import {nationalDistribution} from 'api/enumCode'
import {dateFormat} from 'common/js/tools'
import $ from 'jquery'
export default {
    name: 'WithdrawalUserList',
    data() {
        return {
            activeName: 'apply',
            activityList: [],
            tableData: [],
            total: 0,
            statusList: nationalDistribution.applyStatus,
            loading: false,
            item: {
                localsettlemoney: 0, // 分销待确认金额
                oversettlemoney: 0, // 分销已提金额
                totalbrokerage: 0, // 返现总金额
                unsettlemoney: 0 // 分销未提金额
            },
            selectPage: {
                page: 1,
                pageSize: 10,
                pageCount: 1
            },
            tableUserData: [],
            tableUserPagetotal: 0,
            tableUserPage: {
                page: 1,
                pageSize: 10
            },
            tableApplyPage: {
                page: 1,
                pageSize: 10
            },
            param: {
                eventinnerid: this.$route.query.eventinnerid ? this.$route.query.eventinnerid : '',
                applyStatus: '',
                userStatus: ''
            }
        }
    },
    props: ['flag'],
    mounted() {
        this.power = this.permission.btnObj.A09 ? this.permission.btnObj.A09 : []
        this._getDisEventPageList()
    },
    methods: {
        handleClick() {

        },
        handleApplyExport() {
            this.setLoading(true)
            exportUserApplyCashList({
                data: {eventinnerid: this.param.eventinnerid, status: this.param.status},
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '提现申请' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleUserExport() {
            this.setLoading(true)
            exportUserMayApplyCashList({
                data: {eventinnerid: this.param.eventinnerid, status: this.param.status},
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '可提现用户' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleSearch() {
            this.param.applyStatus = ''
            this.param.userStatus = ''
            this.tableApplyPage.page = 1
            this.tableUserPage.page = 1
            this.setParams(this._.cloneDeep(this.param))
            this._getStatisticsCashInfo()
        },
        remoteMethod(query) {
            if (query !== '') {
                this.loading = true
                this.param.title = query
                this._getDisEventPageList()
            } else {
                this.activityList = []
            }
        },
        handleApplyQuery() {
            this.tableApplyPage.page = 1
            this._getList()
        },
        handleUserQuery() {
            this.tableUserPage.page = 1
            this._getUserList()
        },
        _getStatisticsCashInfo() {
            this.setLoading(true)
            getUserCashInfoSum({
                data: {eventinnerid: this.param.eventinnerid},
                success: data => {
                    this.item = data.data
                    this.setLoading(false)
                    this._getList()
                    this._getUserList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getDisEventPageList() {
            getSimpleDisEventPageList({
                data: Object.assign({}, {title: this.param.title}, this.selectPage),
                success: data => {
                    this.activityList = data.data.content
                    this.selectPage.pageCount = data.data.pageinfo.pageCount
                    let _this = this
                    this.$nextTick(() => {
                        $('.el-scrollbar__wrap').scroll(function () {
                            let scrollTop = Math.floor(this.scrollTop)
                            let clientHeight = this.clientHeight
                            let scrollHeight = Math.floor(this.scrollHeight)
                            if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                                if (_this.selectPage.page < _this.selectPage.pageCount) {
                                    _this.scrollTop = this.scrollTop
                                    _this._getSimpleDisEventPageList()
                                }
                            }
                        })
                    })
                    if (this.activityList.length) {
                        this.param.eventinnerid = this.param.eventinnerid ? this.param.eventinnerid : this.activityList[0].innerid
                        this.handleSearch()
                    }
                    this.loading = false
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.loading = false
                }
            })
        },
        _getSimpleDisEventPageList() {
            this.selectPage.page++
            getSimpleDisEventPageList({
                data: Object.assign({}, {title: this.param.title}, this.selectPage),
                success: data => {
                    this.activityList = this.activityList.concat(data.data.content)
                    this.selectPage.pageCount = data.data.pageinfo.pageCount
                    let _this = this
                    this.$nextTick(() => {
                        $('.el-scrollbar__wrap').scroll(function () {
                            let scrollTop = Math.floor(this.scrollTop)
                            let clientHeight = this.clientHeight
                            let scrollHeight = Math.floor(this.scrollHeight)
                            if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                                if (_this.selectPage.page < _this.selectPage.pageCount) {
                                    _this.scrollTop = this.scrollTop
                                    _this._getSimpleDisEventPageList()
                                }
                            }
                        })
                    })
                    this.loading = false
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.loading = false
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getUserApplyCashList({
                data: Object.assign({}, {eventinnerid: this.param.eventinnerid, status: this.param.applyStatus}, this.tableApplyPage),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getUserList() {
            this.setLoading(true)
            getUserMayApplyCashList({
                data: Object.assign({}, {eventinnerid: this.param.eventinnerid, status: this.param.userStatus}, this.tableUserPage),
                success: data => {
                    this.tableUserData = data.data.content
                    this.tableUserPagetotal = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {
        status: function (value) {
            return value
        }
    },
    watch: {},
    computed: {
        status () {
            return function(value) {
                for (let i = 0; i < nationalDistribution.status.length; i++) {
                    if (value === nationalDistribution.status[i].code) {
                        return nationalDistribution.status[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters([
            'user',
            'permission',
            'params'
        ])
    },
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.WithdrawalUserList {
    .title{
        @include flexBox(space-between);
        height: 60px;
        padding: 0 20px;
        .classes{
            margin-bottom: 0;
        }
        .tip{
            font-size: 14px;
            color: #C0C4CC;
            margin-left: 10px;
        }
    }
    .data-total{
        margin-top: 24px;
        @include flexBox(space-between);
        .outbox{
            padding: 30px;
            height: 100px;
            box-sizing: border-box;
            position: relative;
            flex-grow: 1;
            flex-basis: 200px;
            .box{
                .box-title{
                    font-size: $font-12;
                }
                .box-data{
                    margin-top: 10px;
                    color: $tcolor-blue;
                    font-size: $font-16;
                    .data{
                        font-size: $font-30;
                    }
                }
            }
            .el-tooltip{
                position: absolute;
                width: 14px;
                height: 14px;
                top: 10px;
                right: 10px;
            }
        }
        .outbox+.outbox{
            margin-left: 40px;
        }
    }
    .filters{
        margin-top: 24px;
        padding-left: 0;
        padding-right: 0;
        margin-bottom: 0;
    }
    .result-list{
        .filters{
            margin-top: 0;
        }
    }
    .center{
        .cell{
            text-align: center;
        }
    }
    .right{
        .cell{
            text-align: right;
        }
    }
    .withdrawalUserExp{
        width: 110px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 14px;
    }
    .imageText{
        img{
            width: 50px;
            min-width: 50px;
            max-width: 50px;
            height: 50px;
            border-radius: 50%;
        }
    }
    .el-pagination{
        margin-top: 40px;
        text-align: center;
    }
}
</style>
